const HistoryGridSkeleton = () => {
  return (
    <div className="relative rounded  mt-[30px] h-[100px] bg-secondary-skeleton animate-pulse sm:min-h-[140px] overflow-hidden page-loading"></div>
  )
}

export default HistoryGridSkeleton
